import { BaseResponseType } from '../cognito/authResponse.types';
import { RestaurantResponseType } from '../restaurant/restaurant.types';

export enum EmployeeBreakType {
  MEAL = 'meal',
  REST = 'rest',
}

export enum BreakInfoStatusEnum {
  TAKEN = 'taken',
  WAIVED = 'waived',
  SKIPPED = 'skipped',
  SKIPPED_2 = 'skipped_2',
  MEAL_PENALTY = 'meal-penalty',
  MISSED = 'missed',
  NOT_TAKEN = 'not-taken',
  PARTIALLY_TAKEN = 'partially-taken',
}

export interface BreakType {
  id: number;
  payable: boolean;
  type: EmployeeBreakType;
  duration: number;
  restaurant: RestaurantResponseType;
}

export interface CreateBreakType {
  payable: boolean;
  type: EmployeeBreakType;
  duration: number;
  restaurantId: number;
}
export interface GetBreaksResponseType extends BaseResponseType {
  data: BreakType[] | null;
}
export interface CreateBreakResponseType extends BaseResponseType {
  data: BreakType | null;
}
export interface DeleteBreakResponseType extends BaseResponseType {
  data: null;
}
